import CardForm from "components/CardForm"
import VueForm from "../vue_form"

export default VueForm(CardForm)
